export const CouponType = {
  percentage: "percentage",
  fixed: "fixed",
};

export const TargetType = {
  ALL: "all",
  CATEGORIES: "categories",
  PRODUCTS: "products",
  CATEGORY_PRODUCTS: "categories_products",
};

export const TargetTypeOptions = [
  { _id: TargetType.ALL, name: "Tous", labelKey: "filters.all" },
  { _id: TargetType.CATEGORIES, name: "Catégories", labelKey: "nav.categories" },
  { _id: TargetType.PRODUCTS, name: "Produits", labelKey: "nav.products" },
  { _id: TargetType.CATEGORY_PRODUCTS, name: "Catégories + Produits", labelKey: "filters.categoriesProducts" },
];


export const getCouponLabel = (type) => {
  switch (type) {
    case CouponType.percentage:
      return "Pourcentage";
    case CouponType.fixed:
      return "Fixé";
    default:
      return "Fixé";
  }
};


export const CouponCategory = {
  all: "all",
  categories: "categories",
};

export const getCouponCategoryLabel = (cat) => {
  switch (cat) {
    case CouponCategory.all:
      return "Tout";
    case CouponCategory.categories:
      return "Catégories";
    default:
      return "Tout";
  }
};

export const CouponStatusList = [
  { _id: true, label: "Actif", labelKey: "common.active" },
  { _id: false, label: "Inactif", labelKey: "common.inactive" },
];

/* =======================
   3-way display/filter status
   (Expiré > Actif > Inactif — single source of truth shared by the coupon
   table's État column render and the Coupon screen's État filter, so the
   two can never disagree.)
   ======================= */

export const CouponStatusFilterList = [
  { _id: "active", label: "Actif", labelKey: "common.active" },
  { _id: "inactive", label: "Inactif", labelKey: "common.inactive" },
  { _id: "expired", label: "Expiré", labelKey: "common.expired" },
];

// Resolves a coupon to "active" / "inactive" / "expired" using the exact
// precedence the table display already relies on: isExpired wins over
// isActive, which wins over the inactive fallback.
export const getCouponStatusKey = (coupon) => {
  if (coupon?.isExpired) return "expired";
  if (coupon?.isActive) return "active";
  return "inactive";
};

const CouponStatusMeta = {
  active: { label: "Actif", labelKey: "common.active", color: "success" },
  inactive: { label: "Inactif", labelKey: "common.inactive", color: "warning" },
  expired: { label: "Expiré", labelKey: "common.expired", color: "error" },
};

// Same status key plus its display label/color, for the table's État Chip.
export const getCouponStatusMeta = (coupon) => {
  const key = getCouponStatusKey(coupon);
  return { key, ...CouponStatusMeta[key] };
};

export const CouponTypeList = [
  { _id: CouponType.fixed, label: getCouponLabel(CouponType.fixed), labelKey: "filters.fixed" },
  { _id: CouponType.percentage, label: getCouponLabel(CouponType.percentage), labelKey: "filters.percentage" },
];

/* =======================
   Days of week constants
   ======================= */

export const DaysOfWeek = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

export const DaysOfWeekOptions = [
  { _id: DaysOfWeek.SUNDAY, value: 0, name: "Dimanche", labelKey: "days.sunday" },
  { _id: DaysOfWeek.MONDAY, value: 1, name: "Lundi", labelKey: "days.monday" },
  { _id: DaysOfWeek.TUESDAY, value: 2, name: "Mardi", labelKey: "days.tuesday" },
  { _id: DaysOfWeek.WEDNESDAY, value: 3, name: "Mercredi", labelKey: "days.wednesday" },
  { _id: DaysOfWeek.THURSDAY, value: 4, name: "Jeudi", labelKey: "days.thursday" },
  { _id: DaysOfWeek.FRIDAY, value: 5, name: "Vendredi", labelKey: "days.friday" },
  { _id: DaysOfWeek.SATURDAY, value: 6, name: "Samedi", labelKey: "days.saturday" },
];

export const DaysOfWeekNameToNumber = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

export const formatRecurringDaysForDisplay = (days = []) => {
  if (!Array.isArray(days)) return [];
  return days
    .map((day) => {
      const dayObj = DaysOfWeekOptions.find((d) => d.value === day);
      return dayObj ? dayObj : null;
    })
    .filter(Boolean);
};
